import React, { useEffect } from "react";
import "../Auth/Auth.css";
import loginVec from "../../Assets/Images/successProfileVC.jpeg";
import brandLogo from "../../Assets/Images/brandLogo.png";
import { MdVerified } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useDispatch } from "react-redux";
import { logedInUser } from "../../Redux/slices/AuthSlice";

const SuccessProfile = () => {
  const navigate = useNavigate();
  const [, setCookie, removeCookie] = useCookies(["accessToken"]);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!location?.state?.accessToken) {
      navigate("/sign-in");
    }
  }, [location]);

  const handleClick = () => {
    removeCookie("accessToken", {
      path: "/",
      secure: true,
      httpOnly: false,
      sameSite: "Strict",
    }); // Remove authentication token
    dispatch(logedInUser(location?.state?.user));
    setCookie("accessToken", location?.state?.accessToken, {
      path: "/",
      secure: true,
      httpOnly: false,
      sameSite: "Strict",
      maxAge: 2147483647, // Maximum value for 32-bit integer
    });
    localStorage.setItem("userId", location?.state?.user._id);
    navigate(
      location?.state?.user.role == "Admin" ? "/admin/dashboard" : "/home",
      { state: location?.state?.user }
    );
  };

  return (
    <section
      className="p-6 md:p-4 pb-16 sm:pb-0 min-h-screen flex items-center justify-center"
      style={{
        background: "linear-gradient(131.7deg, #7404FE 3.53%, #42058E 133.97%)",
      }}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 items-stretch w-full max-w-8xl mx-auto gap-0 md:gap-10">
        {/* Right Section (Image & Text) */}
        <div
          className="hidden md:grid relative grid-cols-1 h-full min-h-[calc(100vh-40px)] bg-cover bg-center rounded-xl"
          style={{ backgroundImage: `url(${loginVec})` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-20 rounded-xl"></div>

          <div className="absolute top-0 text-left text-white p-8 w-3/4">
            <img src={brandLogo} alt="Brand Logo" className="w-20 h-20 mb-4 drop-shadow-lg" />
          </div>
          <div className="">
            <div className="absolute bottom-4 mx-4 w-[calc(100%-2rem)] text-left rounded-lg text-white p-3 backdrop-blur-xs border border-white/30 bg-white/10">
              <p className="capitalize text-md">
                We believe communication should be simple, fast and private.
                Whether you're chatting with friends, connecting with family or
                collaborating with your team, our platform ensures seamless
                messaging and end-to-end security.
              </p>
            </div>
          </div>
        </div>

        {/* Left Section */}
        <div className="flex items-center justify-center px-4 md:px-0">
          <div className="w-full max-w-lg">
            <MdVerified className="text-[90px] flex justify-center mx-auto mb-3 text-center text-[#06B300]" />
            <h2 className="text-3xl leading-[50px] font-bold text-white text-center mb-4">
              Congratulations! Your Profile <br /> Has Been Successfully Set!
            </h2>

            <button
              className="w-full bg-white text-black hover:text-white py-3 rounded-full text-lg font-medium hover:bg-purple-500 transition"
              onClick={() => handleClick()}
            >
              Go to Home
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessProfile;
